import {
  ATLAS_NOTES_FEED_SOURCE_KEYS,
  isAtlasNotesFeedSourceKey,
  type NotesFeedSourceKey,
} from "@/lib/notes-feed-remote";

export type NotesFeedBrowseSort = "newest" | "oldest" | "relevance";

export type NotesFeedFilters = {
  search: string;
  sourceKeys: NotesFeedSourceKey[];
  sort: NotesFeedBrowseSort;
  tagKey: string;
};

type SearchParamValue = string | string[] | undefined;

export function parseNotesFeedFilters(searchParams: {
  q?: SearchParamValue;
  sort?: SearchParamValue;
  source?: SearchParamValue;
  tag?: SearchParamValue;
}): NotesFeedFilters {
  const search =
    typeof searchParams.q === "string"
      ? searchParams.q.trim().replace(/\s+/g, " ").slice(0, 200)
      : "";
  const requestedSources = Array.isArray(searchParams.source)
    ? searchParams.source
    : typeof searchParams.source === "string"
      ? [searchParams.source]
      : [];
  const validSources = [
    ...new Set(requestedSources.filter(isAtlasNotesFeedSourceKey)),
  ];
  const sourceKeys =
    requestedSources.length > 0 && validSources.length > 0
      ? validSources
      : [...ATLAS_NOTES_FEED_SOURCE_KEYS];
  const sort =
    searchParams.sort === "oldest"
      ? "oldest"
      : search && searchParams.sort === "relevance"
        ? "relevance"
        : "newest";
  const tagKey =
    typeof searchParams.tag === "string"
      ? searchParams.tag.trim().toLowerCase().slice(0, 200)
      : "";
  return { search, sourceKeys, sort, tagKey };
}

export function notesFeedFilterSearchParams(filters: NotesFeedFilters) {
  const params = new URLSearchParams();
  if (filters.search) params.set("q", filters.search);
  if (filters.sourceKeys.length < ATLAS_NOTES_FEED_SOURCE_KEYS.length) {
    for (const sourceKey of filters.sourceKeys) {
      params.append("source", sourceKey);
    }
  }
  if (
    filters.sort === "oldest" ||
    (filters.search && filters.sort === "relevance")
  ) {
    params.set("sort", filters.sort);
  }
  if (filters.tagKey) params.set("tag", filters.tagKey);
  return params;
}
